import { render } from "./NewUsersAndVisitor.vue?vue&type=template&id=2cb0ec96&scoped=true"
import script from "./NewUsersAndVisitor.vue?vue&type=script&lang=js"
export * from "./NewUsersAndVisitor.vue?vue&type=script&lang=js"

import "./NewUsersAndVisitor.vue?vue&type=style&index=0&id=2cb0ec96&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb0ec96"]])

export default __exports__